export var mutations = {
    setImporting: function (s, payload) {
        s.importing = payload;
    },
    setImported: function (s, payload) {
        s.imported = payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setNewCandidates: function (s, payload) {
        s.newCandidates = payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setDuplicateCandidates: function (s, payload) {
        s.duplicateCandidates = payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setIgnoredCandidates: function (s, payload) {
        s.ignoredCandidates = payload;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setErrors: function (s, payload) {
        s.errors = payload;
    },
};
